import styled from 'styled-components';
import { Modal } from 'antd';

export const FAModal = styled(Modal)`
  .ant-modal-wrap {
    overflow: hidden !important;
  }
  .ant-modal-content {
    border-radius: 0px;
  }
  .ant-modal-header {
    border-bottom: none;
    padding: 30px 50px 0 50px;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      display: flex;
      justify-content: center;
      padding: 20px 0 0 0;
      margin-left: 20px;
      margin-right: 20px;
      border-bottom: 1px solid #d4d4d4;
    }
  }
  .ant-modal-body {
    padding: 10px 50px 0px 50px;
    @media only screen and (min-width: 320px) and (max-width: 991px) {
      padding: 10px 20px 0px 20px;
      height: ${props => props.bodyHeight}px;
      overflow-y: scroll;
    }
  }
  .anticon {
    font-size: 22px;
  }
  .ant-modal-title {
    font-family: ${props => props.theme.fontFamily.berkeleyStd};
    font-size: 24px;
    line-height: 30px;
    letter-spacing: 0.5px;
    color: ${props => props.theme.fontColors.headingColor};
    font-style: normal;
    font-stretch: normal;
    text-align: center;
    padding-bottom: 10px;
    border-bottom: 1px solid #d4d4d4;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      border-bottom: none;
      width: 205px;
      font-size: 20px;
    }
  }
  .ant-modal-footer {
    border-top: none;
    padding: 35px 50px 20px 50px;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      margin: 20px;
      border-top: 1px solid #d4d4d4;
      padding: 20px 62px 20px 62px;
    }
    > div {
      padding-top: 29px;
      justify-content: center;
      display: flex;
      border-top: 1px solid #d4d4d4;
      @media only screen and (min-width: 320px) and (max-width: 767px) {
        padding-top: 0px;
        border-top: none;
      }
      .ant-btn {
        width: 150px;
        height: 50px;
        border: solid 1px ${props => props.theme.fontColors.primary};
        border-radius: 0px;
        font-size: 16px;
        font-style: normal;
        font-stretch: condensed;
        line-height: normal;
        letter-spacing: 0.5px;
        color: ${props => props.theme.fontColors.primary};
        > span {
          font-family: ${props =>
            props.theme.fontFamily.helveticaNeueCondensedBold};
        }
      }
    }
  }
  .ant-modal-footer button + button {
    display: none;
  }
`;

export const Wrapper = styled.div`
  // padding-bottom: 15px;
`;

export const FlexWrapper = styled.div`
  display: flex;
  padding-bottom: 10px;
  border-bottom: 1px solid #d4d4d4;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    flex-direction: column;
  }
`;

export const WrapperDiv = styled.div`
  padding-left: 50px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    padding-left: 0;
    padding-top: 10px;
  }
  ${({ Short }) =>
    Short &&
    `
  width: 274px;
  padding-left: 0px;
  border-right: 1px solid #d4d4d4;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    width: 100%;
    flex-direction: column;
    padding-bottom: 10px;
    border-right: none;
    border-bottom: 1px solid #d4d4d4;
    }
`}
  ${({ Long }) =>
    Long &&
    `
  width: 303px;
  padding-left: 50px;
  border-right: 1px solid #d4d4d4;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    width: 100%;
    padding-top: 10px;
    padding-left: 0px;
    padding-bottom: 10px;
    border-right: none;
    border-bottom: 1px solid #d4d4d4;
    }
  `}
`;

export const Header = styled.h3`
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  font-size: 24px;
  line-height: 30px;
  color: ${props => props.theme.fontColors.headingColor};
  font-style: normal;
  font-stretch: normal;
  letter-spacing: 0.5px;
  margin: 0;
  @media only screen and (max-width: 720px) {
    font-size: 20px;
  }
`;

export const Price = styled.p`
  font-family: ${props => props.theme.fontFamily.helveticaNeueLight};
  font-size: 30px;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${props => props.theme.fontColors.green};
  margin: 0;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: 24px;
  }
`;

export const DateSpan = styled.span`
  display: inline-block;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  color: ${props => props.theme.fontColors.textColor};
  font-size: 16px;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
  @media only screen and (max-width: 720px) {
    font-size: 14px;
  }
`;

export const SubHeading = styled.h4`
  margin: 0;
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  color: ${props => props.theme.fontColors.headingColor};
  font-size: 16px;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
  padding: 10px 0 5px 0;
  @media only screen and (max-width: 720px) {
    font-size: 20px;
    font-family: ${props => props.theme.fontFamily.berkeleyStd};
    font-weight: normal;
  }
`;
